/**
 * REV-355/REV-356: response shape for the AI-narrative draft endpoint.
 *
 * Mirrors what criterionEvaluationController.generateNarrative returns
 * (revenant-api). The contract is the source of truth — runtime
 * validation in auditService.generateNarrative catches drift between
 * api and ui before it surfaces as a confusing UI bug.
 */

import { z } from 'zod';

const NarrativeUsageSchema = z
  .object({
    input_tokens: z.number().int().nonnegative().optional(),
    output_tokens: z.number().int().nonnegative().optional(),
    cache_creation_input_tokens: z.number().int().nonnegative().optional(),
    cache_read_input_tokens: z.number().int().nonnegative().optional(),
  })
  .passthrough();

const GenerateNarrativeResponseSchema = z
  .object({
    success: z.literal(true),
    data: z
      .object({
        narrative: z.string().min(1),
        // UUID from the ai_proxy_calls audit row — surfaced so the UI can
        // show "draft id: …" if a reviewer needs to reference a specific
        // generation in support tickets.
        call_id: z.string().uuid(),
        stop_reason: z.string().nullable(),
        usage: NarrativeUsageSchema.nullable(),
      })
      .strict(),
  })
  .strict();

export type GenerateNarrativeResponse = z.infer<typeof GenerateNarrativeResponseSchema>;

export { GenerateNarrativeResponseSchema, NarrativeUsageSchema };
